export const siteConfig = {
  name: "Studio Click House",
  shortName: "SCHL",
  url: "https://studioclickhouse.com",
  description:
    "Studio Click House provides photo retouching, e-commerce image editing, color grading, and 3D CGI for brands, agencies, photographers, and studios.",
  ogImage: "/images/brand/schl-logo.png",
  links: {
    instagram: "https://www.instagram.com/studioclickhouseltd/",
    linkedin: "https://www.linkedin.com/company/studio-click-house-ltd",
    facebook: "https://www.facebook.com/studioclickhouse/",
    whatsapp: "https://wa.me/8809609777111",
    youtube: "https://www.youtube.com/channel/UCDjIbE0rbDq9PdGXlReHWhg",
  },
  contact: {
    email: "info@studioclickhouse.com",
    phone: "+8809609-777111",
    phoneHref: "+8809609777111",
    website: "www.studioclickhouse.com",
    websiteHref: "https://studioclickhouse.com",
    location: "Level 1, West Boxnagar, Demra, Dhaka-1361",
    country: "Bangladesh",
    timezone: "UTC+6",
    offices: [
      {
        id: "bangladesh",
        country: "Bangladesh",
        city: "Dhaka",
        timezone: "UTC+6",
        address:
          "Level 1, West Boxnagar, Holding: 112/11, Demra, Dhaka-1361",
        phone: "+8809609-777111",
        phoneHref: "+8809609777111",
        email: "info@studioclickhouse.com",
        website: "www.studioclickhouse.com",
        websiteHref: "https://studioclickhouse.com",
      },
      {
        id: "sweden",
        country: "Sweden",
        city: "Stockholm",
        timezone: "UTC+1",
        address: "Stockholm, Sweden",
        phone: "+46855924212",
        phoneHref: "+46855924212",
        email: "info@studioclickhouse.com",
      },
      {
        id: "australia",
        country: "Australia",
        city: "Sydney",
        timezone: "UTC+10",
        address: "Sydney, Australia",
        phone: "+61483963759",
        phoneHref: "+61483963759",
        email: "info@studioclickhouse.com",
      },
      {
        id: "uk",
        country: "United Kingdom",
        city: "London",
        timezone: "UTC+0",
        address: "London, UK",
        phone: "+443330047739",
        phoneHref: "+443330047739",
        email: "info@studioclickhouse.com",
      },
      {
        id: "usa",
        country: "United States",
        city: "New York",
        timezone: "UTC-5",
        address: "New York, USA",
        phone: "+1 917 722 5590",
        phoneHref: "+19177225590",
        email: "info@studioclickhouse.com",
      },
    ],
  },
};
